export default __webpack_public_path__ + "static/media/COLOR BOOTH.b877869a.png";